import { DELETE_CATEGORY_SUCCESS } from '../categories/constants';
import {
  GET_USER_BY_COGNITO_ID,
  GET_USER_BY_COGNITO_ID_FAILED,
  GET_USER_BY_COGNITO_ID_SUCCESS,
  RESET_USER_STATE,
  GET_TAGS,
  GET_TAGS_SUCCESS,
  GET_TAGS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  UPLOAD_PROFILE_PICTURE,
  UPLOAD_PROFILE_PICTURE_SUCCESS,
  UPLOAD_PROFILE_PICTURE_FAILED,
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  GET_REGISTERED_VENUE_OWNERS,
  GET_REGISTERED_VENUE_OWNERS_SUCCESS,
  GET_REGISTERED_VENUE_OWNERS_FAILED,
  GET_USERS_RATING_BY_ROLE,
  GET_USERS_RATING_BY_ROLE_SUCCESS,
  GET_USERS_RATING_BY_ROLE_FAILED,
  DELETE_USER_RATING,
  DELETE_USER_RATING_FAILED,
  GET_VENDOR_USERS,
  GET_VENDOR_USERS_SUCCESS,
  GET_VENDOR_USERS_FAILED,
  ON_SEARCH_VENDOR_USER,
  GET_USERS_VENUE_VENDORS,
  GET_USERS_VENUE_VENDORS_SUCCESS,
  GET_USERS_VENUE_VENDORS_FAILED,
  ON_SEARCH_USERS,
  DISABLE_USER_BY_TERMS_ANDS_CONDITIONS,
  DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_FAILED,
  DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_SUCCESS,
  GET_VENDORS_BY_VENUE,
  GET_VENDORS_BY_VENUE_SUCCESS,
  GET_VENDORS_BY_VENUE_FAILED,
  CREATE_USER_ASSET,
  UPDATE_USER_ASSET,
  DELETE_USER_ASSET,
  CREATE_USER_ASSET_SUCCESS,
  CREATE_USER_ASSET_FAILED,
  UPDATE_USER_ASSET_SUCCESS,
  UPDATE_USER_ASSET_FAILED,
  DELETE_USER_ASSET_SUCCESS,
  DELETE_USER_ASSET_FAILED,
  GET_USER_BY_ID,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_FAILED,
} from './constants';

export const getUsers = () => ({
  type: GET_USERS,
});

export const getUsersSuccess = (users) => ({
  type: GET_USERS_SUCCESS,
  payload: { users },
});

export const getUsersFailed = (error) => ({
  type: GET_USERS_FAILED,
  payload: { error },
});

export const getUserByCognitoId = (cognitoId, navigate) => ({
  type: GET_USER_BY_COGNITO_ID,
  payload: { cognitoId, navigate },
});

export const disableUserByTermsAndConditions = (message, userId, eventId) => ({
  type: DISABLE_USER_BY_TERMS_ANDS_CONDITIONS,
  payload: { message, userId, eventId },
});

export const disableUserByTermsAndConditionSuccess = (userId) => ({
  type: DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_SUCCESS,
  payload: { userId },
});

export const disableUserByTermsAndConditionFailed = (error) => ({
  type: DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_FAILED,
  payload: { error },
});

export const getUserByCognitoIdSuccess = (user) => ({
  type: GET_USER_BY_COGNITO_ID_SUCCESS,
  payload: { user },
});

export const getUserByCognitoIdFailed = (error) => ({
  type: GET_USER_BY_COGNITO_ID_FAILED,
  payload: { error },
});

export const resetUserState = () => ({
  type: RESET_USER_STATE,
});

const getTags = () => ({
  type: GET_TAGS,
  payload: {},
});

const getTagsSuccess = (tagsList) => ({
  type: GET_TAGS_SUCCESS,
  payload: { tagsList },
});

const getTagsFailed = (error) => ({
  type: GET_TAGS_FAILED,
  payload: { error },
});

const editUser = (user) => ({
  type: EDIT_USER,
  payload: { user },
});

const editUserSuccess = (user) => ({
  type: EDIT_USER_SUCCESS,
  payload: { user },
});

const editUserFailed = (error) => ({
  type: EDIT_USER_FAILED,
  payload: { error },
});
const uploadPicture = (user) => ({
  type: UPLOAD_PROFILE_PICTURE,
  payload: { user },
});

const uploadPictureSuccess = (user) => ({
  type: UPLOAD_PROFILE_PICTURE_SUCCESS,
  payload: { user },
});

const uploadPictureFailed = (error) => ({
  type: UPLOAD_PROFILE_PICTURE_FAILED,
  payload: { error },
});

const getRegisteredVenueOwners = (filter) => ({
  type: GET_REGISTERED_VENUE_OWNERS,
  payload: { filter },
});

const getRegisteredVenueOwnersSuccess = (users) => ({
  type: GET_REGISTERED_VENUE_OWNERS_SUCCESS,
  payload: { users },
});

const getRegisteredVenueOwnersFailed = (error) => ({
  type: GET_REGISTERED_VENUE_OWNERS_FAILED,
  payload: { error },
});

const getUsersRatingByRole = () => ({
  type: GET_USERS_RATING_BY_ROLE,
  payload: {},
});

const getUsersRatingByRoleSuccess = (ratings) => ({
  type: GET_USERS_RATING_BY_ROLE_SUCCESS,
  payload: { ratings },
});

const getUsersRatingByRoleFailed = (error) => ({
  type: GET_USERS_RATING_BY_ROLE_FAILED,
  payload: { error },
});

const deleteUserRating = (rating) => ({
  type: DELETE_USER_RATING,
  payload: { rating },
});

const deleteUserRatingSuccess = (ratings) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: { ratings },
});

const deleteUserRatingFailed = (error) => ({
  type: DELETE_USER_RATING_FAILED,
  payload: { error },
});

const getVendorUsers = () => ({
  type: GET_VENDOR_USERS,
});

const getVendorUsersSuccess = (users) => ({
  type: GET_VENDOR_USERS_SUCCESS,
  payload: { users },
});

const getVendorUsersFailed = (error) => ({
  type: GET_VENDOR_USERS_FAILED,
  payload: { error },
});

const onSearchVendorUsers = (text) => ({
  type: ON_SEARCH_VENDOR_USER,
  payload: { text },
});

const getVenueVendorUsers = () => ({
  type: GET_USERS_VENUE_VENDORS,
});

const getVenueVendorUsersSuccess = (users) => ({
  type: GET_USERS_VENUE_VENDORS_SUCCESS,
  payload: { users },
});

const getVenueVendorUsersFailed = (error) => ({
  type: GET_USERS_VENUE_VENDORS_FAILED,
  payload: { error },
});

export const onSearchUsers = (text) => ({
  type: ON_SEARCH_USERS,
  payload: { text },
});

const getVendorsByVenue = (venueId) => ({
  type: GET_VENDORS_BY_VENUE,
  payload: { venueId },
});

const getVendorsByVenueSuccess = (users) => ({
  type: GET_VENDORS_BY_VENUE_SUCCESS,
  payload: { users },
});

const getVendorsByVenueFailed = (error) => ({
  type: GET_VENDORS_BY_VENUE_FAILED,
  payload: { error },
});

const createUserAsset = (asset) => ({
  type: CREATE_USER_ASSET,
  payload: { asset },
});

const createUserAssetSuccess = (userAsset) => ({
  type: CREATE_USER_ASSET_SUCCESS,
  payload: { userAsset },
});

const createUserAssetFailed = (error) => ({
  type: CREATE_USER_ASSET_FAILED,
  payload: { error },
});

const updateUserAsset = (userAsset) => ({
  type: UPDATE_USER_ASSET,
  payload: { userAsset },
});

const deleteUserAsset = (assetId) => ({
  type: DELETE_USER_ASSET,
  payload: { assetId },
});

const deleteUserAssetSuccess = (userAsset) => ({
  type: DELETE_USER_ASSET_SUCCESS,
  payload: { userAsset },
});

const deleteUserAssetFailed = (error) => ({
  type: DELETE_USER_ASSET_FAILED,
  payload: { error },
});

const getUserById = (userId) => ({
  type: GET_USER_BY_ID,
  payload: { userId },
});

const getUserByIdSuccess = (userById) => ({
  type: GET_USER_BY_ID_SUCCESS,
  payload: { userById },
});

const getUserByIdFailed = (error) => ({
  type: GET_USER_BY_ID_FAILED,
  payload: { error },
});

export {
  getTags,
  getTagsSuccess,
  getTagsFailed,
  editUser,
  editUserSuccess,
  editUserFailed,
  uploadPicture,
  uploadPictureSuccess,
  uploadPictureFailed,
  getRegisteredVenueOwners,
  getRegisteredVenueOwnersSuccess,
  getRegisteredVenueOwnersFailed,
  getUsersRatingByRole,
  getUsersRatingByRoleSuccess,
  getUsersRatingByRoleFailed,
  deleteUserRating,
  deleteUserRatingSuccess,
  deleteUserRatingFailed,
  getVendorUsers,
  getVendorUsersFailed,
  getVendorUsersSuccess,
  onSearchVendorUsers,
  getVenueVendorUsers,
  getVenueVendorUsersSuccess,
  getVenueVendorUsersFailed,
  getVendorsByVenue,
  getVendorsByVenueSuccess,
  getVendorsByVenueFailed,
  createUserAsset,
  createUserAssetSuccess,
  createUserAssetFailed,
  updateUserAsset,
  deleteUserAsset,
  deleteUserAssetSuccess,
  deleteUserAssetFailed,
  getUserById,
  getUserByIdSuccess,
  getUserByIdFailed,
};
